

  import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
  import {isMobile} from "mobile-device-detect";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component
  export default class AppDialog extends Vue {
    @Prop() title: string;
    @Prop() currentPopup: { blockName: string; dialogName: string; };
    @Prop() isVisible!: boolean;
    @Prop({ default: false }) mobilePopup!: boolean;
    @Prop({ default: false }) hideContentProp!: boolean;
    @Prop() customHeader!: boolean;
    @Prop({ default: true }) closeOnClickModal!: boolean;
    @Prop({ default: true }) closeOnPressEscape!: boolean;
    @Prop({ default: false }) loading!: boolean;
    @Prop() closeAction!: Function;

    animateDisplay = false;

    get storeState(): IAppState { return this.$store.state; }
    get displayPopup() {
      return this.storeState.dialog[this.currentPopup.blockName][this.currentPopup.dialogName]
        || this.isVisible;
    }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get hideContent() {
      let firstPopup = this.storeState.dialog.stackPopup[0];
      let blockName = this.currentPopup.blockName;
      let dialogName = this.currentPopup.dialogName;

      return !(firstPopup && firstPopup.blockName === blockName && firstPopup.dialogName === dialogName) || this.hideContentProp;
    }

    async mounted() {
      if (isMobile) setTimeout(() => this.animateDisplay = true, 0);
      else this.animateDisplay = true;
    }

    async onClose() {
      if (this.closeAction) await this.closeAction();
      this.animateDisplay = false;
      if (this.payloadPopup.closeAction) await this.payloadPopup.closeAction();

      if (isMobile) setTimeout(async () => await this.closeCurrentPopup(), 500);
      else await this.closeCurrentPopup();
    }

    async closeCurrentPopup() {
      await this.$store.dispatch('dialog/closeDialog', {
        blockName: this.currentPopup.blockName,
        dialogName: this.currentPopup.dialogName,
      });
    }
  }
